import { saveFiltersToStorage, createDebouncedSave } from "../../utils/filterPersistenceUtils";

/**
 * Redux middleware to automatically save filter state to localStorage
 * when filter actions are dispatched, with debouncing to prevent excessive writes.
 */

// Create a debounced save function with 500ms delay
const debouncedSave = createDebouncedSave(saveFiltersToStorage, 500);

// Filter action types that should trigger persistence
const FILTER_ACTION_TYPES = [
  // New shared actions
  'filterPersistence/setSharedFilters',
  'filterPersistence/setProgramFilter',
  'filterPersistence/setSurgeonFilter',
  'filterPersistence/setRecFilter',
  'filterPersistence/clearSharedFilters',
  // Legacy actions
  'filterPersistence/setPlanFilters',
  'filterPersistence/setHistoricalFilters',
  'filterPersistence/setPlanProgramFilter',
  'filterPersistence/setPlanSurgeonFilter',
  'filterPersistence/setPlanRecFilter',
  'filterPersistence/setHistoricalProgramFilter',
  'filterPersistence/setHistoricalSurgeonFilter',
  'filterPersistence/setHistoricalRecFilter',
  'filterPersistence/clearPlanFilters',
  'filterPersistence/clearHistoricalFilters',
  'filterPersistence/clearAllFilters',
];

/**
 * Middleware function that intercepts filter actions and saves state to localStorage
 */
export const filterPersistenceMiddleware = (store) => (next) => (action) => {
  // Call the next middleware/reducer first
  const result = next(action);

  // Check if this action should trigger persistence
  if (FILTER_ACTION_TYPES.includes(action.type)) {
    // Get the current filter state after the action has been processed
    const state = store.getState();
    const filterState = state.filterPersistence;

    // Save to localStorage with debouncing
    debouncedSave(filterState);
  }

  return result;
};

export default filterPersistenceMiddleware;
